import { useMemo } from 'react';
import { toIcons } from '../../consts/Paths';
import Avatar from './Avatar';
import { possible_statuses } from '../../consts/possible_statuses';

const SideBarUserSection = (props: any) => {
    const role = useMemo(() => (props.user?.roles.find((e: any) => e.role === possible_statuses.userType.admin) ? 'Admin' : 'Normal'), [props.user?.roles]);
    return (
        <div className='sidebar-user-box'>
            <div className='sidebar-user-imageSpot-mask'>{props.user && <Avatar user={props.user} size={40} />}</div>
            <div className='sidebar-user-info'>
                <p className='sidebar-user-info-name'>{`${props.user?.name}`}</p>
                <p className='sidebar-user-info-type'>{role}</p>
            </div>
            {/* <div className="sidebar-user-icon-combined">
        <img
          className="sidebar-user-icon-shape"
          src={`${toIcons}/small-up.svg`}
        />
        <img
          className="sidebar-user-icon-shape"
          src={`${toIcons}/small-down.svg`}
        />
      </div> */}
        </div>
    );
};
export default SideBarUserSection;
